<template>
  <div class="cycle-package-widget-edit relative">
    <menu-item label="活动">
      <activity-select v-model="model.activityId" :type="15" :support-chain="false" />
    </menu-item>

    <menu-item label="背景设置">
      <menu-background-image :target="model.background" target-key="background" />
      <menu-fill class="mt-2" :target="model.background" target-key="background" />
    </menu-item>

    <menu-item label="封面">
      <menu-background-image :target="model.coverBackground" target-key="coverBackground" />
    </menu-item>

    <menu-item label="领奖日期未选中背景">
      <menu-fill :target="model.dateUnselectedBackground" solid-color target-key="dateUnselectedBackground" />
    </menu-item>

    <menu-item label="领奖日期未选中文字">
      <menu-fill :target="model.dateUnselectedTextColor" solid-color target-key="dateUnselectedTextColor" />
    </menu-item>

    <menu-item label="领奖日期选中填充">
      <menu-fill :target="model.dateSelectedBackground" solid-color target-key="dateSelectedBackground" />
    </menu-item>

    <menu-item label="领奖日期选中文字">
      <menu-fill :target="model.dateSelectedTextColor" solid-color target-key="dateSelectedTextColor" />
    </menu-item>

    <menu-item label="奖品区域背景">
      <menu-fill :target="model.rewardAreaBackground" solid-color target-key="rewardAreaBackground" />
    </menu-item>

    <menu-item label="购买/领取按钮填充">
      <menu-fill :target="model.btnBackground" solid-color target-key="btnBackground" />
    </menu-item>

    <menu-item label="不可领取按钮填充">
      <menu-fill :target="model.btnDisabledBackground" solid-color target-key="btnDisabledBackground" />
    </menu-item>

    <menu-item label="按钮文字色">
      <menu-fill :target="model.btnTextColor" solid-color target-key="btnTextColor" />
    </menu-item>

    <menu-item label="文字颜色">
      <menu-fill :target="model.textColor" solid-color target-key="textColor" />
    </menu-item>

    <menu-item label="圆角">
      <menu-slider v-model="model.borderRadius" :max="50" :min="0" target-key="borderRadius" />
    </menu-item>

    <menu-item label="自动弹出规则">
      <im-select v-model="model.popupRule" :options="popupRuleOptions" />
    </menu-item>
    <menu-item label="是否开启悬浮按钮">
      <menu-switch v-model="model.floatingBtn" target-key="floatingBtn" />
      <menu-background-image v-if="model.floatingBtn" class="mt-2" :target="model.floatingBtnBackground" target-key="floatingBtnBackground" />
    </menu-item>
    <remove-btn class="mt-4" />
  </div>
</template>

<script>
import RemoveBtn from '~/components/common/RemoveBtn.vue'
import MenuTitle from '~/components/menu/menuTitle.vue'
import MenuItem from '~/components/menu/menuItem.vue'
import MenuSelect from '~/components/menu/menuSelect.vue'
import MenuBackgroundImage from '~/components/menu/menuBackgroundImage.vue'
import MenuFill from '~/components/menu/menuFill.vue'
import MenuSlider from '~/components/menu/menuSlider.vue'
import ActivitySelect from '~/site/components/activitySelect/index.vue'
import MenuSwitch from '~/components/menu/menuSwitch.vue'



export default {
  name: 'CyclePackageWidgetEdit',
  components: {
    RemoveBtn,
    MenuTitle,
    MenuItem,
    MenuSelect,
    MenuBackgroundImage,
    MenuFill,
    MenuSlider,
    ActivitySelect,
    MenuSwitch
  },
  props: {
    model: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      popupRuleOptions: [
        { label: 'UID每日一次', value: 'uid_daily' },
        { label: '设备每日一次', value: 'device_daily' }
      ]
    }
  }
}
</script>

<style lang="less" scoped>
.cycle-package-widget-edit {
  padding-bottom: 20px;

  .gap-2 {
    gap: 8px;
  }
}
</style>
